import React from "react";
// import { WixCategoriesUIProvider } from "./WixCategoriesUIContext";
import Activity from "./Activity";
import { ActivityUIProvider } from "./ActivityUIContext";

export function ActivityPage({ history }) {
  return (
    <ActivityUIProvider >
      <Activity />
    </ActivityUIProvider>
  );
}
